import * as React from "react";
import { Badge, type BadgeProps } from "./badge";

type PostingState = "DRAFT" | "OPEN" | "CLOSED" | "EXPIRED" | "CANCELLED";

const POSTING_LABEL: Record<PostingState, string> = {
  DRAFT: "Nháp",
  OPEN: "Đang tuyển",
  CLOSED: "Đã đóng",
  EXPIRED: "Hết hạn",
  CANCELLED: "Đã huỷ",
};

const POSTING_TONE: Record<PostingState, BadgeProps["tone"]> = {
  DRAFT: "smoke",
  OPEN: "lime",
  CLOSED: "ink",
  EXPIRED: "mist",
  CANCELLED: "danger-soft",
};

export function PostingStateBadge({ state }: { state: PostingState }) {
  return <Badge tone={POSTING_TONE[state]}>{POSTING_LABEL[state]}</Badge>;
}

type ApplicationState =
  | "APPLIED"
  | "INVITED"
  | "ACCEPTED"
  | "COMMITTED"
  | "REJECTED"
  | "WITHDRAWN"
  | "EXPIRED";

const APP_LABEL: Record<ApplicationState, string> = {
  APPLIED: "Chờ duyệt",
  INVITED: "Được mời PV",
  ACCEPTED: "Đã chọn lịch",
  COMMITTED: "Đã xác nhận",
  REJECTED: "Đã từ chối",
  WITHDRAWN: "Đã rút",
  EXPIRED: "Hết hạn",
};

const APP_TONE: Record<ApplicationState, BadgeProps["tone"]> = {
  APPLIED: "sun",
  INVITED: "lime",
  ACCEPTED: "lime",
  COMMITTED: "lime",
  REJECTED: "danger-soft",
  WITHDRAWN: "smoke",
  EXPIRED: "smoke",
};

export function ApplicationStateBadge({ state }: { state: ApplicationState }) {
  return <Badge tone={APP_TONE[state]}>{APP_LABEL[state]}</Badge>;
}

type PaymentStatus = "PENDING" | "PAID" | "EXPIRED" | "REFUNDED" | "FAILED";

const PAY_LABEL: Record<PaymentStatus, string> = {
  PENDING: "Chờ thanh toán",
  PAID: "Đã thanh toán",
  EXPIRED: "Hết hạn",
  REFUNDED: "Đã hoàn tiền",
  FAILED: "Thất bại",
};

const PAY_TONE: Record<PaymentStatus, BadgeProps["tone"]> = {
  PENDING: "sun",
  PAID: "lime",
  EXPIRED: "smoke",
  REFUNDED: "info-soft",
  FAILED: "danger-soft",
};

export function PaymentStatusBadge({ status }: { status: PaymentStatus }) {
  return <Badge tone={PAY_TONE[status]}>{PAY_LABEL[status]}</Badge>;
}

type KycStatus = "NONE" | "PENDING" | "APPROVED" | "REJECTED" | "EXPIRED";

const KYC_LABEL: Record<KycStatus, string> = {
  NONE: "Chưa xác thực",
  PENDING: "Chờ duyệt",
  APPROVED: "Đã xác thực",
  REJECTED: "Từ chối",
  EXPIRED: "Hết hạn",
};

const KYC_TONE: Record<KycStatus, BadgeProps["tone"]> = {
  NONE: "smoke",
  PENDING: "sun",
  APPROVED: "lime",
  REJECTED: "danger-soft",
  EXPIRED: "ember-soft",
};

export function KycStatusBadge({ status }: { status: KycStatus }) {
  return <Badge tone={KYC_TONE[status]}>{KYC_LABEL[status]}</Badge>;
}

type UserStatus = "ACTIVE" | "SUSPENDED" | "DELETED";

const USER_LABEL: Record<UserStatus, string> = {
  ACTIVE: "Đang hoạt động",
  SUSPENDED: "Đã khoá",
  DELETED: "Đã xoá",
};

const USER_TONE: Record<UserStatus, BadgeProps["tone"]> = {
  ACTIVE: "lime",
  SUSPENDED: "ember-soft",
  DELETED: "smoke",
};

export function UserStatusBadge({ status }: { status: UserStatus }) {
  return <Badge tone={USER_TONE[status]}>{USER_LABEL[status]}</Badge>;
}
